import React, { memo, useCallback, useMemo } from 'react';
import { Handle, Position } from 'reactflow';
import Icon from './Icon';
import { formatTimeDelta } from './timeUtils';
import ConditionDisplay from './ConditionDisplay';

export default memo(({ data = {}, id }) => {
  const onAddNode = useCallback((event) => {
    event.stopPropagation();
    if (window.bubbleInstance) {
      window.bubbleInstance.publishState('add_from_node_id', id);
      window.bubbleInstance.publishState('add_from_handle_id', null); // Clear branch handle for action nodes
      window.bubbleInstance.triggerEvent('add_node_requested');
    }
  }, [id]);

  // Determine tag styling and default icons based on node type or tag (memoized)
  const { tagStyle, defaultTagIcon, defaultIcon } = useMemo(() => {
    const tag = data.tag?.toLowerCase() || '';
    if (tag.includes('trigger') || tag.includes('check')) {
      return { tagStyle: 'trigger', defaultTagIcon: 'lightning', defaultIcon: 'lightning' };
    } else if (tag.includes('webhook') || tag.includes('api')) {
      return { tagStyle: 'webhook', defaultTagIcon: 'globe', defaultIcon: 'globe' };
    } else if (tag.includes('email') || tag.includes('notification')) {
      return { tagStyle: 'notification', defaultTagIcon: 'envelope', defaultIcon: 'envelope' };
    } else {
      return { tagStyle: 'action', defaultTagIcon: 'gear', defaultIcon: 'gear' };
    }
  }, [data.tag]);

  // Build CSS classes based on node state
  const nodeClasses = [
    'custom-node',
    data.isSelected ? 'selected' : '',
    data.isConnectedToSelectedEdge ? 'connected-to-selected-edge' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={nodeClasses}>
      <Handle type="target" position={Position.Top} style={{ opacity: 0 }} />
      <div className={`node-tag ${tagStyle}`}>
        <Icon name={data.tagIcon || defaultTagIcon} size={12} weight={data.iconWeight || 'regular'} />
        {data.tag}
      </div>
      <div className="node-content">
        <div className="node-main-content">
          <div className="node-icon">
            <Icon name={data.icon || defaultIcon} size={24} weight={data.iconWeight || 'regular'} />
          </div>
          <div className="node-body">
            <p className="node-title">{data.title}</p>
            {!(data.type?.toLowerCase() === 'trigger' || data.tag?.toLowerCase().includes('trigger')) && (
              <p className="node-description">{formatTimeDelta(data.timeDelta)}{data.description}</p>
            )}
          </div>
        </div>
        {!(data.type?.toLowerCase() === 'trigger' || data.tag?.toLowerCase().includes('trigger')) && (
          <ConditionDisplay conditions={data.conditions} />
        )}
      </div>
      <Handle type="source" position={Position.Bottom} style={{ opacity: 0 }} />
      {!data.hasBranchChild && (
        <div 
          className="add-node-button" 
          onClick={onAddNode}
        >
          +
        </div>
      )}
    </div>
  );
}); 